export default [{
  name: 'nellpay',
  namespaced: true,
  state: {},
  mutations: {},
  getters: {},
  actions: {
    beforeEach ({ getters, commit }, { to, from, next }) {
      switch (to.fullPath) {
        case '/':
          if (localStorage.ambiente) { next({ path: '/partner/' + localStorage.ambiente }) }
          break;
      }
    }
  },
  logoutFunctions: {
    afterClear (state) {
      location.href = '/partner/' + state.empresa.ambiente
    },
  }
}]
